<!-- 渠道列表 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">渠道列表</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 5px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		<div class="screen-box">
			<div class="screen-label">渠道名称</div>
			<a-input v-model="r_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">渠道内容类型</div>
				
			<!-- <a-select 
			 style="width: 240px" 
			 placeholder="未选择"
			:getPopupContainer="getsPopupContainer"
			 @change="handleChangeA" 
			 showSearch 
			 allowClear
			>
				<a-select-option :value="1">H5书城</a-select-option>
				<a-select-option :value="2">快应用书城</a-select-option>
				<a-select-option :value="3">短剧</a-select-option>
			</a-select> -->
			<a-select
				style="width: 240px"
				placeholder="请选择渠道内容"
				@change="handleChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				allowClear
			  >
				<a-select-option v-for="(value,key) in filterData.content_channel.list" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary" class="screen-box">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 渠道ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.channel_id}}
			</div>
			<!-- 渠道名称 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.channel_name}}
			</div>
			<!-- 渠道内容类型 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.content_type_name}}
			</div>
			<!-- 返点比率 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.return_point}}
			</div>
			<!-- 类型 -->
			<!-- <div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.type | tableToText}}
			</div> -->
			<!-- 操作 -->
			<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_null_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" />
		
	</div>
	
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">渠道名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_channel_name" placeholder="请输入" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">渠道ID<span class="required-hint">*</span></div>
					
				<a-input v-model="x_channel_id" placeholder="请输入" type="number" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">渠道返点<span class="required-hint">*</span></div>
					
				<a-input v-model="x_return_point" placeholder="请输入" style="width: 240px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">渠道内容类型<span class="required-hint">*</span></div>
					
				<a-select :value="x_type_id" 
				 style="width: 240px" 
				 placeholder="未选择"
				:getPopupContainer="getsPopupContainer"
				 @change="handleChangeQ" 
				 showSearch 
				>
					<a-select-option v-for="(value,key) in filterData.content_channel.list" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<!-- <div class="form-cell-box">
				<div class="class-title">外部渠道ID</div>
					
				<a-input v-model="x_foreign_channel_id" placeholder="请输入" type="number" style="width: 240px;"  />
			</div> -->
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { channelLists, channelAdd, channelEdit, putDataMenu } from '@/request/api'
export default {
	name: 'channelList_',
	components: {
		
	},
	data() {
		return {
			// 筛选条件部分
			filterData: {
				content_channel: {},
			}, // 筛选条件数组
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"渠道ID", width:200, type:"channel_id", },
				{title:"渠道名称", width:200, type:"channel_name", },
				{title:"渠道内容类型", width:200, type:"content_type_name", },
				{title:"返点", width:200, type:"return_point", },
				// {title:"类型", width:200, type:"type", },
				{title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false,
			
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			r_type_id: undefined,
			r_name: null,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_channel_name: "", // 渠道名称
			x_channel_id: "", // 渠道ID
			x_return_point: "", // 渠道返点
			x_foreign_channel_id: 0, // 外部渠道ID
			x_type: "0", // 渠道类型 0=投放 1=运营
			x_id: "", // id，用于编辑
			x_type_id: undefined, // 渠道内容类型
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		putDataMenu().then((res)=>{
			that.filterData = res.data.data.filter
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){
			this.r_type_id = e
		},
		handleChangeQ(e){
			this.x_type_id = e
		},
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			// type:0这里是固定拿投放的数据
			channelLists({
				page: that.r_page, 
				limit: that.r_limit,
				type:"0",
				content_type: that.r_type_id, // 1=H5书城，2=快应用书城，3=短剧
				channel_name: that.r_name
			}).then(res=>{
				console.log("渠道列表",res.data);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增按钮
		addButton(){
			this.drawer_title = "新增"
			this.visible = true
		},
		// 编辑
		editTable(index,e){
			console.log(e);
			let that = this
			this.drawer_title = "编辑"
			
			this.x_id = e.id
			this.x_channel_name = e.channel_name
			this.x_channel_id = e.channel_id
			this.x_return_point = e.return_point
			this.x_foreign_channel_id = e.foreign_channel_id
			let ccc = undefined
			if(e.content_type){
				ccc = e.content_type.toString()
			}
			this.x_type_id =  ccc
			
			this.visible = true
		},
		// 新增/编辑
		addRequest(){
			let that = this
			if(!that.x_channel_name){
				that.add_form_hint = "请填写渠道名称"
			}
			else if(!that.x_channel_id){
				that.add_form_hint = "请填写渠道ID"
			}
			else if(!that.x_return_point){
				that.add_form_hint = "请填写返点比例"
			}
			else if(!that.x_type_id){
				that.add_form_hint = "渠道内容类型"
			}
			else {
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					channelAdd({
						channel_id: that.x_channel_id,
						channel_name: that.x_channel_name,
						return_point: that.x_return_point,
						foreign_channel_id: that.x_foreign_channel_id,
						type: that.x_type,
						content_type: that.x_type_id,
					}).then(res=>{
						console.log("新增",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					channelEdit({
						id: that.x_id,
						channel_id: that.x_channel_id,
						channel_name: that.x_channel_name,
						return_point: that.x_return_point,
						foreign_channel_id: that.x_foreign_channel_id,
						type: that.x_type,
						content_type: that.x_type_id,
					}).then(res=>{
						console.log("编辑",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			// if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
			// 	return
			// }
			
			this.x_id = ""
			this.x_channel_name = ""
			this.x_channel_id = ""
			this.x_return_point = ""
			this.x_foreign_channel_id = ""
			
			this.x_type_id = undefined
			
			this.add_form_hint = ""
			
			this.visible = false
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton()
		}
	},
	filters: {
		tableToText(value){
			// console.log("过滤器",value)
			let text 
			if(value == 0){
				text = "投放"
			}
			else if(value == 1){
				text = "运营"
			}
			return text
		}
	}
}	
</script>

<style scoped>


</style>